// extracted by mini-css-extract-plugin
export default {"title":"Loader_title__JEbTM","items":"Loader_items__JD-Rr","item":"Loader_item__4apB7"};